import {
  GhostButton,
  PrimaryButton,
  Space,
  Text,
  ButtonGroup,
} from "@certn/cascadia";
import { SectionMessage } from "@certn/cascadia-react";
import { t } from "i18next";
import React, { useContext } from "react";
import { Trans } from "react-i18next";

import { DCOReviewContext } from "../DCOReviewContext";
import { DCOReviewPageLayout } from "../DCOReviewLayout";

export function DisputeConfirmStep() {
  const { goToNextStep, goToPrevStep } = useContext(DCOReviewContext);

  return (
    <DCOReviewPageLayout onComplete={goToNextStep} nextDisabled={false}>
      <Text
        style="form/body-primary"
        color="text-base"
        testID="Dispute-confirm-subtext"
      >
        <Trans>
          You have indicated that your results of your{" "}
          <strong>Nationally Coordinated Criminal History Check (NCCHC)</strong>{" "}
          are not as expected.
        </Trans>
      </Text>
      <Space />
      <SectionMessage>
        <Text
          style="global/heading-small"
          color="text-base"
          testID="Dispute-confirm-greytext-subtitle"
        >
          <Trans>
            You have the right to dispute the outcome of your Check Result if
            you believe any of the following scenarios apply:
          </Trans>
        </Text>
        <Space />
        <Text style="global/body-secondary">
          <ul>
            <li>
              <Trans>
                The police information released does not belong to you
              </Trans>
            </li>
            <li>
              <Trans>
                Part of the police information does not belong to you
              </Trans>
            </li>
            <li>
              <Trans>
                The police information belongs to you, but the details are
                inaccurate
              </Trans>
            </li>
            <li>
              <Trans>
                The police information belongs to you, but should not have been
                released
              </Trans>
            </li>
            <li>
              <Trans>
                Police information belonging to you has not been returned
              </Trans>
            </li>
          </ul>
        </Text>
      </SectionMessage>
      <ButtonGroup justify="end">
        <GhostButton leftIcon="chevron_left" onPress={goToPrevStep}>
          {t("Go back")}
        </GhostButton>
        <PrimaryButton
          onPress={goToNextStep}
          testID="next-step-complete-dco-review-button"
        >
          {t("Next step")}
        </PrimaryButton>
      </ButtonGroup>
    </DCOReviewPageLayout>
  );
}
